import { FC } from 'react';
import { useTranslation } from '../../hooks/use-translation';

interface Props {
  query?: string;
  isNotFound?: boolean
}

// -----------------------------------------------------------------------------
export const SearchResultsPlaceHolder: FC<Props> = props => {
  const { query, isNotFound = false } = props;
  const { t } = useTranslation();

  return (
    <>
      {isNotFound &&
        <div className='no-results-found'>
          <img
            src='/static_next/img/no-results.webp'
            alt={`${t('searchResults.noResults')}`}
          />
          <h2>
            {t('searchResults.noResults')}
            <br />“<span>{query}</span>”
          </h2>
          <p
            dangerouslySetInnerHTML={{ __html: t('searchResults.tryAgain') }} 
          />
        </div>
      }

      {!isNotFound &&
        <div className='start-search'>
          <img
            width={514}
            height={316}
            src='/static_next/img/start-search.webp'
            alt={`${t('searchResults.startSearch')}`}
          />
          <h2>{t('searchResults.startSearch')}</h2>
        </div>
      }
    </>
  );
};
